module.exports = __webpack_public_path__ + "static/media/appsAndSessionLight.bf9a14cb.svg";